import requests from "./httpService";

const PartialPaymentServices = {
  getAllPartialPayment: async () => {
    return requests.get(`/booking/getPartialPercentage`);
  },



  updatePartialPayment: async (body) => {
    return requests.put(`/booking/updatePartialPercentage`, body);
  },




 
};

export default PartialPaymentServices;
